module.exports = __webpack_public_path__ + "public/images/prizes/prize-uae-2.372f95d85a5b02f4e8f4fa298427da2b.jpg";